import tippy from 'tippy.js';

['turbo:frame-load', 'turbo:load'].forEach(function(ev) {
  document.addEventListener(ev, function(e) {

    /* --------------------------------------------------
                  Init
    -------------------------------------------------- */
    const vdTippyInit = function(){
      tippy('[data-js="tippy"]', {
        offset: '0, 2',
        animation: 'fade',
        arrow: true,
        delay: [0, 0]
      });
    }

    /* --------------------------------------------------
                  Functions
    -------------------------------------------------- */
    vdTippyInit();
  });
})
